export default __webpack_public_path__ + "static/media/teacher_login_pear_practice.608ba3ea.png";